import useEntity from "../../hooks/useThicknessClass";
import ThicknessClassDetail from "../../components/thicknessClass/ThicknessClassDetail/ThicknessClassDetail";
import ThicknessClassScoped from "../../components/thicknessClass/ThicknessClassDetail/ThicknessClassScoped";
import ThicknessClassTabs from "../../components/thicknessClass/ThicknessClassDetail/ThicknessClassTabs";
import { useGetThicknessClassQuery } from "../../apis/ThicknessClass.api";
import { PrimaryThicknessClass } from "../../types/models/ThicknessClass";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const ThicknessClassDetailPage = () => {

    useTitle(t`Details Thickness Class`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { thicknessClassId: id } = useParams();

    const { data, refetch } = useGetThicknessClassQuery(PrimaryThicknessClass.fromPath(id))
    const { deleteThicknessClass } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteThicknessClass(data, '..')
    }, [data, deleteThicknessClass])

    if (id === 'scoped') {
        return (<ThicknessClassScoped/>)
    }

    return (
        <Box data-testid="ThicknessClass-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <ThicknessClassDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/ThicknessClasses/update/view'
        ) ||
false) &&
                        <Button size="small" variant="outlined" data-testid="ThicknessClass-edit-button" startIcon={<Edit />}
                                component={NavLink}
                                to="edit"
                                relative="route"
                                viewTransition={true}
                        >
                            <Trans>Edit</Trans>
                        </Button>
                    }
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/ThicknessClasses/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="ThicknessClass-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <ThicknessClassTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default ThicknessClassDetailPage;
